var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCryptoGlyph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34C27.732 34 34 27.732 34 20C34 12.268 27.732 6 20 6C12.268 6 6 12.268 6 20C6 27.732 12.268 34 20 34ZM18.8926 30.0154H17.7432V28.0281H15.251V13.0428H17.7432V11.034H18.8926V13.0428H20.4609V11.034H21.6211V13.0643C24.0703 13.2254 25.6172 14.6434 25.6172 16.7811C25.6172 18.3924 24.4248 19.7996 22.8887 20.0467V20.1326C24.9189 20.3152 26.3477 21.7869 26.3477 23.7742C26.3477 26.2986 24.5645 27.8885 21.6211 28.0174V30.0154H20.4609V28.0281H18.8926V30.0154ZM20.4395 15.159H17.9688V19.327H20.0205C21.8896 19.327 22.9424 18.575 22.9424 17.1678C22.9424 15.868 22.0186 15.159 20.4395 15.159ZM17.9688 21.282V25.9119H20.5684C22.5127 25.9119 23.5869 25.1277 23.5869 23.5809C23.5869 22.0662 22.4912 21.282 20.4502 21.282H17.9688Z",
    fill: "white"
  })));
}

export default SvgCryptoGlyph;